/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Cancel_ButtonInputs */

const fr_membership_plan_change_cancel_button = /** @type {(inputs: Membership_Plan_Change_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler le changement`)
};

/**

* @param {Membership_Plan_Change_Cancel_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_cancel_button = /** @type {((inputs?: Membership_Plan_Change_Cancel_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Cancel_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_cancel_button(inputs)
});